import { useContext, useState } from 'react';
import Cards from '../../../assets/images/carde.png'

// @styles 
import './styles.scss'
import cx from 'classnames';
import CardsAdditional from '../cards-additional';
import { Button, Form, InputNumber, notification } from 'antd';
import { useEffect } from 'react';
import { formatPrice, getBody, getBodyCalculator, getNotificationStyle, getPrice, getUrl, setFieldsValue } from 'utils/utils';
import Context from 'context/appContext';
import ModalWarning from 'components/modal-warning';
import LoadingProcedure from 'components/loading-procedure';

export default function CardsCoverages({ info, form, current, index }) {
    const [api, contextHolder] = notification.useNotification();
    const [defaultClass, setDefaultClass] = useState('default');
    const [isClassActive, setIsClassActive] = useState(false);
    const [alert, setAlert] = useState(false);
    const [loadingComponent, setLoadingComponent] = useState(true);
    const [financialSupport, setFinancialSupport] = useState([]);
    const [financialSupportPack, setFinancialSupportPack] = useState({});
    const { dataForm: { data, formResponses }, customRequest, setDataForm, formStatus: { steps, currentStep, currentQuestion },
        setPriceToShow, setSidebarData, setAdditionalCoverages, sidebarData, setReturnButton, setDisabledButtonContinue, activeKey, priceToShow, setActiveKey, currency, setCurrency, isActiveAditionals } = useContext(Context);
    const infoAditional = current && current.newItems && current.newItems.find((field) => field && field.key === 'proteccionAdicionalParaTi');
    const regex = /\B(?=(\d{3})+(?!\d))/g;
    const covTerceros = [];
    const additionals = ['TEV', 'FHM'];
    const messageAdd = "Tu cobertura ha sido agregada con éxito";
    const messageRemove = "Tu cobertura ha sido removida con éxito";

    useEffect(() => {
        getRespaldos();
        additionals && additionals.forEach((key) => {
            const indexAdd = formResponses.findIndex(x => x.key === key);
            indexAdd === -1 && setFieldsValue(key, true, null, formResponses, form);
        })
    }, []);

    useEffect(() => {
        getSidebarData();
    }, [currency, priceToShow, activeKey]);

    useEffect(() => {
        if (financialSupportPack && financialSupport.length > 0) { resetCoverages(financialSupportPack); }
    }, [currency]);

    useEffect(() => { !priceToShow && financialSupport && financialSupport.length > 0 && sidebarData && serviceCalculator(); getSidebarData(); }, [financialSupport])

    const getcoverages = (packCoverages, reset) => {
        let coverages = []
        packCoverages && packCoverages.forEach((section) => {
            section && section.coverages && section.coverages.forEach((cov) => {
                const limits = cov.currencyLimit && cov.currencyLimit[getIndexDependency(cov) ? getIndexDependency(cov) : 0]; // limits **
                const insuredSumDefault =
                    !reset ? limits && limits.mxn.min :
                        currency ? limits && limits.mxn.min : limits && limits.usd.min;
                cov['insuredSumDefault'] = insuredSumDefault;
                if (cov && cov.input && reset) { setFieldsValue(cov.code, !cov.mandatory ? 0 : insuredSumDefault, null, formResponses, form); }
                coverages.push(cov);
            })
        })
        const isPrincipalCov = (cov) => {
            return cov && cov.input && cov.currencyLimit && cov.currencyLimit[0] && cov.currencyLimit[0].insuredSumCriteria === null
        };
        coverages.sort((a, b) => { return Number(b.mandatory) - Number(a.mandatory) });
        coverages.sort((a, b) => { return Number(isPrincipalCov(b)) - Number(isPrincipalCov(a)) });
        return coverages
    }

    const getRespaldos = async () => {
        setLoadingComponent(true);
        setReturnButton(false);
        setDisabledButtonContinue(true);
        const infoRequest = info && info.content;
        const opciones_servicio = getUrl(infoRequest, formResponses);
        const resCoverages = await customRequest(opciones_servicio.url, opciones_servicio.headers, opciones_servicio.method, null);
        data['infoCoverages'] = { resCoverage: resCoverages, infoRequest };
        const indexResCoverages = formResponses.findIndex(x => x.key === 'resCoverages');
        if (await resCoverages && resCoverages.data) {
            resCoverages['key'] = 'resCoverages';
            if (indexResCoverages !== -1) {
                formResponses[indexResCoverages] = resCoverages;
            } else {
                formResponses.push(resCoverages)
            }
            const financialSupportPackages = resCoverages.data && resCoverages.data.financialSupport.sections;
            const addCoveragesPack = resCoverages.data && resCoverages.data.additionalCoverages.sections[0] && resCoverages.data.additionalCoverages.sections[0].subsections;
            setAdditionalCoverages(addCoveragesPack);
            setFinancialSupportPack(financialSupportPackages);
            setFinancialSupport(getcoverages(financialSupportPackages));
            setDisabledButtonContinue(false);
        } else if (resCoverages && resCoverages.errors) {
            const errors = resCoverages && resCoverages.errors
            setAlert({ active: true, message: errors.description, fields: errors.fields })
        }
        setReturnButton(true);
        setLoadingComponent(false);
    }

    useEffect(() => {
        setDisabledButtonContinue(loadingComponent);
        setReturnButton(!loadingComponent);
    }, [loadingComponent]);

    const serviceCalculator = async (newFormResponse) => {
        setLoadingComponent(true);
        const valPrimary = steps[currentStep] && steps[currentStep].questions[currentQuestion] && steps[currentStep].questions[currentQuestion].primary;
        const options = valPrimary && valPrimary.opciones_servicio_segundo_plano
            ? valPrimary.opciones_servicio_segundo_plano
            : '';
        const opciones_servicio = options && JSON.parse(options);
        const body = getBodyCalculator(opciones_servicio.body, newFormResponse || formResponses, form);
        await customRequest(opciones_servicio.url, opciones_servicio.header, opciones_servicio.method, body).then((res) => {
            if (res && res.errors) {
                const errors = res && res.errors
                setAlert({ active: true, message: errors.description, fields: errors.fields })
            }
            res && res.data && res.data.totalPremium && setPriceToShow(res.data.totalPremium);
            return false
        })
        setLoadingComponent(false);
    }

    useEffect(() => {
        const IndexMonedaId = formResponses.findIndex(x => x.key === 'monedaId')
        IndexMonedaId === -1 && formResponses.push({ key: "monedaId", value: currency ? 'MXN' : 'USD' });
    }, [currency]);

    const getSublimitOrValue = (coverage) => {
        let sum = 0
        const index = coverage && coverage.index >= 0 && Number(coverage.index)
        const currencyLimit = coverage && coverage.currencyLimit && coverage.currencyLimit[index];
        currencyLimit && currencyLimit.insuredSumCriteria && currencyLimit.insuredSumCriteria.dependencies
            && currencyLimit.insuredSumCriteria.dependencies.forEach((key) => {
                const valueCovDependency = Number(form.getFieldValue(key));
                sum = sum + (valueCovDependency >= 0 ? getPrice(Number(valueCovDependency)) : 0);
            })
        const formula = currencyLimit && currencyLimit.insuredSumCriteria && currencyLimit.insuredSumCriteria.formula && currencyLimit.insuredSumCriteria.formula.replace(/[SUM({dependencias})]{19}|[EQ({dependencias})]{18}/g, sum);
        const subLimit = formula && eval(formula);
        let valueField = getPrice(Math.floor(subLimit));
        if (coverage && coverage.code && !coverage.input && getPrice(Math.floor(subLimit)) > 0) {
            valueField = coverage && coverage.typeCoverage && additionals.includes(coverage.typeCoverage) ? isActiveAditionals[coverage.typeCoverage] ? valueField : 0 : valueField;
            const indexField = coverage && formResponses.findIndex(x => x.code === coverage.code);
            coverage['value'] = valueField
            indexField !== -1 ? formResponses[indexField]['value'] = valueField : formResponses.push(coverage)
        }
        return valueField
    }

    const getSidebarData = () => {
        const sidebarData = { title: 'COBERTURAS', items: [] };
        let rowsBasic = [];
        let rawsAdditional = [];
        let rowsOptionals = [];
        const allCovs = formResponses.filter(cov => cov && cov.code && cov.value && cov.typeCoverage === 'OPC' || cov && cov.code === '1143');
        const totalCovOptionals = financialSupport.concat(allCovs);
        totalCovOptionals && totalCovOptionals.forEach(coverage => {
            const limitCalculated = getSublimitOrValue(coverage);
            const subLimit = limitCalculated ? limitCalculated :
                coverage && coverage.index >= 0 ? coverage.insuredSumDefault : null;
            coverage && !coverage.input && coverage.typeCoverage === 'BAS' && (coverage.index >= 0) && (limitCalculated) && rawsAdditional.push({
                label: coverage.description,
                value: formatPrice(subLimit)
            })


            const limits = coverage && coverage.currencyLimit && coverage.currencyLimit[getIndexDependency(coverage) ? getIndexDependency(coverage) : 0]; // limits **
            const valueF = form.getFieldValue(coverage.code);
            ((coverage && coverage.input && coverage.mandatory && valueF) || (coverage && coverage.input && limits && !limits.insuredSumCriteria && valueF)) && rowsBasic.push({
                label: coverage.description,
                value: formatPrice(valueF)
            })

            const valueCapturado = form.getFieldValue(coverage.code);
            if ((coverage.typeCoverage === 'OPC') && !getSublimitOrValue(coverage) && valueCapturado && limits && limits.insuredSumCriteria) {
                setFieldsValue(coverage.code, 0, coverage, formResponses, form);
                coverage.value = 0
                activeKey[coverage.code] && setActiveKey({ ...activeKey, [coverage.code]: false })
                // console.log(activeKey, coverage, limitCalculated, limits);
            }

            coverage && (coverage.input || coverage.typeCoverage === 'OPC') && !coverage.mandatory &&
                valueCapturado && (limits && limits.insuredSumCriteria !== null || coverage.typeCoverage === 'OPC') && (valueCapturado || subLimit) && rowsOptionals.push({
                    label: coverage.description,
                    value: formatPrice((valueCapturado))
                })

        });

        sidebarData.items.push(
            {
                title: 'Básicas Seleccionadas',
                values: [{
                    rows: rowsBasic
                }]
            }
        )

        sidebarData.items.push(
            {
                title: 'Opcionales Seleccionadas',
                values: [{
                    rows: rowsOptionals
                }]
            }
        )
        rawsAdditional && rawsAdditional.length > 0 && sidebarData.items.push(
            {
                title: 'Adicionales Incluidas',
                values: [{
                    rows: rawsAdditional
                }]
            }
        )
        sidebarData.items.push(
            {
                title: 'Asistencias Básicas Incluídas',
                values: [{
                    rows: []
                }]
            }
        );
        sidebarData['key'] = 'sidebarData'
        const indexData = formResponses.findIndex(x => x.key === 'sidebarData');
        indexData !== -1 ? formResponses[indexData] = sidebarData : formResponses.push(sidebarData);
        setSidebarData([sidebarData])
        return [sidebarData];
    }

    const renderCoverages = () => {
        return financialSupport && financialSupport.map((card) => {
            const indexField = formResponses.findIndex(x => x.code === card.code);
            indexField === -1 && formResponses.push(card);
            const coverageInput = card && card.input ? card : null;
            const limits = coverageInput && coverageInput.currencyLimit[getIndexDependency(coverageInput) ? getIndexDependency(coverageInput) || 0 : 0]; // limits **
            const mandatory = coverageInput && coverageInput.mandatory;
            const limitCurrency = currency ? limits && limits.mxn : limits && limits.usd;
            const defaultValue = coverageInput && limitCurrency.min;
            const codeCoverage = coverageInput && coverageInput.code;
            const limitCalculated = getSublimitOrValue(coverageInput);
            coverageInput && coverageInput.code && !mandatory && !activeKey[codeCoverage] && setFieldsValue(coverageInput.code, 0, coverageInput, formResponses, form)
            const maxValue = limitCurrency && ((limitCalculated && limitCalculated < limitCurrency.min) ? limitCurrency.min : (limitCalculated > limitCurrency.max) ? limitCurrency.max : limitCalculated);
            card['maxValue'] = maxValue;
            if (coverageInput && (maxValue || limits && !limits.insuredSumCriteria && formatPrice(limitCurrency.max))) {
                return (
                    card &&
                    <div className={cx(
                        'coverages-economy__content-items-card',
                        { 'active-card': (mandatory ? true : activeKey[codeCoverage]) }
                    )}>
                        <div className='coverages-economy__content-items-card-body'>
                            <div className='coverages-economy__content-items-card-body__header'>
                                <div className='coverages-economy__content-items-card-body__header-detail'>
                                    <img className='coverages-economy__content-items-card-body__header-detail__img' src={card && card.render && card.render.img ? card.render.img : Cards} alt={card?.render?.title} onClick={() => !mandatory && onActiveClassCard(codeCoverage, mandatory, coverageInput, defaultValue)} />
                                    <div className='coverages-economy__content-items-card-body__header-detail__text' onClick={() => !mandatory && onActiveClassCard(codeCoverage, mandatory, coverageInput, defaultValue)}                    >
                                        <h3 className='coverages-economy__content-items-card-body__header-detail__text-title' >
                                            {card && card.render && card.render.title}
                                        </h3>
                                        <p className='coverages-economy__content-items-card-body__header-detail__text-description'>
                                            {card && card.render && card.render.body}
                                        </p>
                                    </div>
                                </div>
                                <div className='coverages-economy__content-items-card-body__header-detail__btn'>
                                    <Button className='ant-btn-outline c-2' onClick={() => !mandatory && onActiveClassCard(codeCoverage, mandatory, coverageInput, defaultValue)}>
                                        Agregar
                                    </Button>
                                    <div className={`coverages-economy__content-items-card-body__header-detail__btn-plus ${mandatory ? 'no-select' : ''}`} onClick={() => !mandatory && onActiveClassCard(codeCoverage, mandatory, coverageInput, defaultValue)} />
                                </div>
                            </div>

                        </div>
                        <div className='coverages-economy__content-items-card-footer__price'>
                                <p className='coverages-economy__content-items-card-footer__price-value'>
                                    <Form.Item onClick={() => { }}>
                                        <Form.Item name={codeCoverage} onClick={() => { }}>
                                            <InputNumber
                                                id={codeCoverage}
                                                min={limitCurrency.min}
                                                max={limits && !limits.insuredSumCriteria ? formatPrice(limitCurrency.max) : maxValue}
                                                maxLength={21}
                                                formatter={value => `${value}`.replace(/[^0-9]/g, '').replace(regex, ',')}
                                                defaultValue={getDefaultValue(coverageInput, defaultValue, limitCurrency)}
                                                onBlur={(e) => {
                                                    onBlur(e, coverageInput, limits && !limits.insuredSumCriteria ? limitCurrency.max : maxValue, limitCurrency)
                                                }}
                                                autoComplete="off"
                                                required={mandatory}
                                            />
                                        </Form.Item>
                                        <span className="suffix">{currency ? 'MXN' : 'USD'}</span>
                                    </Form.Item>
                                </p>
                                <div className='coverages-economy__content-items-card-footer__price-text'>
                                    <strong>SUMA ASEGURADA</strong>
                                    <div>
                                        <p>MÍNIMO: <p>{formatPrice(limitCurrency.min)}</p></p>
                                        <p>MÁXIMO: <p>{limits && !limits.insuredSumCriteria ? formatPrice(limitCurrency.max) : formatPrice(maxValue)}</p></p>
                                    </div>
                                </div>
                            </div>
                    </div>
                )
            } else if (coverageInput && coverageInput.code) {
                setFieldsValue(coverageInput.code, 0, coverageInput, formResponses, form);
                activeKey[codeCoverage] && setActiveKey({ ...activeKey, [codeCoverage]: false });
            }
        })
    }

    const getIndexDependency = (coverage, activeKeyP) => {
        const currencyLimit = coverage && coverage.currencyLimit
        let indexPrioridad = null; let index = null; let render = false; let arrayV = []; let indexs = []; let caseExclude = false; let caseNotDependency = null;
        currencyLimit && currencyLimit.forEach((element, indexE) => {
            let array = [];
            let validaciones = [];
            const dependency = element && element.insuredSumCriteria && element.insuredSumCriteria.dependencies;
            const insuredSumCriteria = element && element.insuredSumCriteria && element.insuredSumCriteria;
            caseNotDependency = !insuredSumCriteria ? indexE : null
            dependency && dependency.forEach((coverageKey) => {
                if (activeKeyP) {
                    activeKeyP[coverageKey] && array.push(true);
                } else {
                    activeKey && activeKey[coverageKey] && array.push(true)
                    const activeKeysTerceros = covTerceros && covTerceros[0] && covTerceros[0].code;
                    coverageKey && (coverageKey === activeKeysTerceros) && array.push(true)
                    caseExclude = (coverageKey && activeKeysTerceros && insuredSumCriteria && (coverageKey === activeKeysTerceros)) ? indexE : caseExclude;
                    if (caseExclude >= 0) {
                        coverage['index'] = indexE
                    }
                }
            })
            if (!dependency && !coverage.typeCoverage) {
                caseExclude = indexE
                coverage['index'] = indexE
            }

            validaciones = array && array.map(x => x === true)
            render = (currencyLimit && validaciones && validaciones.length) === (dependency && dependency.length);
            index = render ? indexE : index
            render && currencyLimit.length > 1 && arrayV.push({ [indexE]: validaciones.length })

            currencyLimit.length > 1 && arrayV && arrayV.forEach((indexLenght, i) => {
                indexs.push(index)
                indexPrioridad = (indexLenght[index] > (arrayV[i - 1] && arrayV[i - 1][indexs[i - 1]]))
                    ? index : indexs[i - 1]
            })
        })
        return indexPrioridad >= 0 && indexPrioridad !== null && indexPrioridad !== undefined ? indexPrioridad : caseNotDependency || (caseExclude >= 0 ? caseExclude : false) || index
    }

    const onActiveClassCard = async (key, mandatory, coverageInput, defaultValue) => {

        let value = defaultValue
        const codeCoverage = coverageInput && coverageInput.code;
        const select = activeKey && activeKey[codeCoverage];
        const index = formResponses.findIndex(x => x.code === codeCoverage);
        coverageInput['value'] = value;
        index !== -1 ? formResponses[index].value = value : formResponses.push(coverageInput);
        form.setFieldsValue({ [codeCoverage]: Math.floor(value) });

        if (!mandatory) {
            const keyActiveK = 'activeKeys';
            const copyActiveKey = JSON.parse(JSON.stringify(activeKey));
            select && setFieldsValue(key, 0, null, formResponses, form);
            setActiveKey({ ...activeKey, [key]: !select });
            const indexActiveKey = formResponses.findIndex(x => x.code === keyActiveK);
            indexActiveKey !== -1 ? formResponses[indexActiveKey].value = { ...copyActiveKey, [key]: !select } : formResponses.push({ code: keyActiveK, value: { ...copyActiveKey, [key]: !select } });
        }
        await serviceCalculator();
        getSidebarData();
        !mandatory && openNotification(!select);
    }

    const openNotification = (choosed, messageChange) => {
        if (choosed) {
            openNotificationWithIcon("success", messageChange || messageAdd);
        } else {
            openNotificationWithIcon("error", messageRemove);
        }
    };

    const openNotificationWithIcon = (type, description) => {
        api[type]({
            message: ``,
            description,
            style: getNotificationStyle(type),
        });
    };

    const resetCoverages = async (financialSupportPack) => {
        const newFormResponse = formResponses.filter(x => !x.code);
        setActiveKey({});
        setDataForm(dataForm => ({ ...dataForm, formResponses: newFormResponse }));
        await financialSupportPack && setFinancialSupport(getcoverages(financialSupportPack, true));
        await serviceCalculator(newFormResponse);
    }

    const onClick = (monedaId) => {
        const IndexMonedaId = formResponses.findIndex(x => x.key === 'monedaId');
        const currencyClick = monedaId === 'USD' ? false : true;
        IndexMonedaId !== -1 ? formResponses[IndexMonedaId].value = monedaId :
            formResponses.push({ key: "monedaId", value: monedaId });
        setDefaultClass('active-btn-left');
        setCurrency(currencyClick);
        setIsClassActive({ ...isClassActive, [index]: !currencyClick, [0]: currencyClick });
        openNotification(true, `Se ha aplicado la configuración predefinida para ${monedaId}`);
    }

    const getDefaultValue = (coverage, defaultValue, limitCurrency) => {
        const code = coverage && coverage.code;
        const index = formResponses.findIndex(x => x.code === code);
        let value = form.getFieldValue(code);
        const isMandatory = coverage.mandatory;
        if (!isMandatory && (index === -1 || !activeKey[code])) {
            value = 0
            coverage['value'] = 0;
            setValue(value, coverage);
            index === -1 && formResponses.push(coverage);
        } else if (isMandatory && index === -1 || isMandatory && index !== -1 && !formResponses[index]?.value) {
            setValue(defaultValue, coverage)
        }
        else if (!isMandatory && !activeKey[code]) {
            setValue(0, coverage);
        } else if ((!isMandatory && value !== 0 && !value && value !== null) || (isMandatory && !value && value !== '' && value !== 0 && value !== null)) {
            value = coverage.mandatory ? getPrice(defaultValue) ?
                getPrice(defaultValue) : limitCurrency.min
                : formResponses[index].value;
            setValue(value, coverage);
        }
    }

    const onBlur = (e, coverageInput, max, limitCurrency) => {
        let value = Number(getPrice(e && e.target && e.target.value));
        const minValue = limitCurrency && limitCurrency.min;
        const maxvalue = max;
        const codeCoverage = coverageInput && coverageInput.code;
        const index = formResponses.findIndex(x => x.code === coverageInput.code);
        if (!coverageInput.mandatory && value === 0 && (e.target.value === '' || e.target.value === '0')) {
            onActiveClassCard(codeCoverage, coverageInput.mandatory, coverageInput, coverageInput.defaultValue);
        } else {
            value = value >= maxvalue ? maxvalue : value <= minValue ? minValue : value;
            coverageInput['value'] = value;
            index !== -1 ? formResponses[index].value = value : formResponses.push(coverageInput);
            form.setFieldsValue({ [codeCoverage]: Math.floor(value) });
        }
        getSidebarData();
        serviceCalculator();
    }

    const setValue = (value, coverage) => {
        const index = formResponses.findIndex(x => x.code === coverage.code);
        coverage.value = value ? Number(value) : 0;
        index !== -1 ? formResponses[index].value = value : formResponses.push(coverage);
        form.setFieldsValue({ [coverage.code]: value })
    }

    return (
        <>
            {contextHolder}
            {loadingComponent && (<LoadingProcedure message={'Cotizando'} />)}
            {alert && alert.active && <ModalWarning info={{ visible: true, type: 'error', message: alert && alert.message, fields: alert.fields }} callBack={() => setAlert({ active: false })} />}
            <div className='coverages-economy'>
                <div className='coverages-economy__title'>
                    <p>Respaldo Económico de Bienes</p>
                    <div className='smallswitch__container' id={index}>
                        <div className='smallswitch__container__buttons' id={index}>
                            <button className={`smallswitch__container__buttons-btn ${currency && defaultClass}`}
                                disabled={currency}
                                onClick={() => onClick('MXN')}>
                                <span>MXN</span>
                            </button>
                            <button className={`smallswitch__container__buttons-btn ${!currency ? 'active-btn-right' : ''}`}
                                disabled={!currency}
                                onClick={() => onClick('USD')}>
                                <span>USD</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div className='coverages-economy__content'>
                    <div className='coverages-economy__content-items'>
                        {renderCoverages()}
                    </div>
                </div>
                <CardsAdditional info={infoAditional} form={form} current={current} openNotification={openNotification} index={Math.random()} serviceCalculator={() => { serviceCalculator() }} />
            </div>
        </>
    )
}